import React from 'react'
import { Autoplay, Pagination, EffectCoverflow } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import Container from '../../Container/Container'
import "./FirstBanner.css"
import rogLaptops from '../../../assets/images/product/banner/rog-laptops.jpg'
import motherboards from '../../../assets/images/product/banner/motherboards.jpg'
import laptops from '../../../assets/images/product/banner/laptops.jpg'
import laptopAsus from '../../../assets/images/product/banner/laptop-asus.jpg'
import keyboard from '../../../assets/images/product/banner/banner-keyboard.webp'
import vag from '../../../assets/images/product/banner/vga.png'



function FirstBanner() {
    return (
        <>
            <Container class1='pt-5 ' >
                <div className="row FirstBanner bdrs20 pt-3">
                    <div className="row col-12 p-0 m-0 ">
                            <Swiper
                                effect={"coverflow"}
                                grabCursor={true}
                                autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                }}
                                centeredSlides={true}
                                slidesPerView={"auto"}
                                coverflowEffect={{
                                    rotate: 40,
                                    stretch: 0,
                                    depth: 100,
                                    modifier: 1,
                                    slideShadows: true,
                                }}
                                initialSlide={1}
                                modules={[Autoplay, EffectCoverflow, Pagination]}
                                className="mySwiper bdrs20 "  >
                                <SwiperSlide>
                                    <img src={rogLaptops} alt='لپتاپ ایسوس' className='img-fluid h-100 bdrs20 borderBanner' />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img src={motherboards} alt='مادربرد ایسوس' className='img-fluid h-100 bdrs20 borderBanner' />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img src={laptops} alt='لپتاپ ایسوس' className='img-fluid h-100 bdrs20 borderBanner' />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img src={laptopAsus} alt='لپتاپ' className='img-fluid h-100 bdrs20 borderBanner' />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img src={keyboard} alt='لپتاپ' className='img-fluid h-100 bdrs20 borderBanner' />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img src={vag} alt='لپتاپ' className='img-fluid h-100 bdrs20 borderBanner' />
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
            </Container >
        </>
    )
}

export default FirstBanner